/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ProductsAboveAveragePriceService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { ProductsAboveAveragePriceData, ProductsAboveAveragePriceService } from './ProductsAboveAveragePrice.service';
import { ProductsAboveAveragePriceSearchComponent }  from './ProductsAboveAveragePriceSearch.component';

@Component({
	selector: 'my-ProductsAboveAveragePrice',
	template: require('./ProductsAboveAveragePriceList.component.html'),
	providers: [ProductsAboveAveragePriceService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ProductsAboveAveragePriceListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	ProductsAboveAveragePriceList: ProductsAboveAveragePriceData[];
	newProductsAboveAveragePrice: ProductsAboveAveragePriceData;
	selectedProductsAboveAveragePrice: ProductsAboveAveragePriceData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(ProductsAboveAveragePriceSearchComponent) filterComponent: ProductsAboveAveragePriceSearchComponent;

	sortExpression: string = "ProductName";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private ProductsAboveAveragePriceService: ProductsAboveAveragePriceService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newProductsAboveAveragePrice = new ProductsAboveAveragePriceData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.ProductsAboveAveragePriceService.getAll().subscribe(record => this.ProductsAboveAveragePriceList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getProductsAboveAveragePriceByPaging();

		/*
		this.ProductsAboveAveragePriceList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getProductsAboveAveragePrice() {
		this.ProductsAboveAveragePriceService.getAll()
			.subscribe(data => this.ProductsAboveAveragePriceList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on ProductsAboveAveragePriceSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getProductsAboveAveragePriceByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getProductsAboveAveragePriceByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getProductsAboveAveragePriceByPaging();
	}
	
	// Get records by paging
	getProductsAboveAveragePriceByPaging() {
		this.ProductsAboveAveragePriceService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.ProductsAboveAveragePriceList=data.ProductsAboveAveragePriceList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addProductsAboveAveragePrice() {
		this.ProductsAboveAveragePriceService.addProductsAboveAveragePriceData(this.newProductsAboveAveragePrice).subscribe(record => console.log(record));
		this.getProductsAboveAveragePrice();
	}
  
	// Updates existing record
	updateProductsAboveAveragePrice() {
		this.ProductsAboveAveragePriceService.updateProductsAboveAveragePriceData(this.selectedProductsAboveAveragePrice).subscribe(record => console.log(record));
		this.getProductsAboveAveragePrice();
	}

	// Deletes record with specified id
	deleteProductsAboveAveragePrice(id: string) {
		if (window.confirm('Are you sure you want to delete this ProductsAboveAveragePrice?') == true)
		{
			this.ProductsAboveAveragePriceService.deleteProductsAboveAveragePrice(id)
			.subscribe(data => this.getProductsAboveAveragePrice(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getProductsAboveAveragePriceByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getProductsAboveAveragePriceByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getProductsAboveAveragePriceByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getProductsAboveAveragePriceByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: ProductsAboveAveragePriceData) {
		this.router.navigate(['/ProductsAboveAveragePrice', item.ProductName]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: ProductsAboveAveragePriceData) {
		this.router.navigate(['/ProductsAboveAveragePrice/Details', item.ProductName]);
	}

	// Set record as selected
	SelectProductsAboveAveragePrice(item: ProductsAboveAveragePriceData) {
		this.selectedProductsAboveAveragePrice = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: ProductsAboveAveragePriceData) {
		return item.ProductName === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductsAboveAveragePrice/ProductsAboveAveragePriceList.component.ts